var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"2199a94d226856ac1670bc93c8ac8fa26e44625d"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["portal---prod@loadsure"]={id:"2199a94d226856ac1670bc93c8ac8fa26e44625d"};
      